import { IkasBaseModel } from "../../base";

export type IkasBlogMetaData = {
  canonicals?: string[] | null;
  description?: string | null;
  disableIndex?: boolean | null;
  pageTitle?: string | null;
  slug: string;
  targetId?: string | null;
  targetType?: IkasBlogMetaDataTargetType | null;
} & IkasBaseModel;

export enum IkasBlogMetaDataTargetType {
  BLOG = "BLOG",
  BLOG_CATEGORY = "BLOG_CATEGORY",
}
